<div class="insights-panel">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
        <button
            *ngFor="let tab of tabs"
            class="tab-button"
            [class.active]="isActiveTab(tab.id)"
            (click)="setActiveTab(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tile-content">
        <!-- Current Schedule Tab -->
        <div *ngIf="isActiveTab('current-schedule')" class="tab-pane">
            <div class="insights-parent">
                <app-disinfection-current-schedule-tile
                    [eventName]="'Wet Cleaning (Weekly)'"
                    [eventPlace]="'Farm Alpha - House A - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Scheduled'"
                    [assignedTo]="'James Thomas'"
                    [lastDate]="'2024-06-20'"
                ></app-disinfection-current-schedule-tile>
                <app-disinfection-current-schedule-tile
                    [eventName]="'Fogging (Daily)'"
                    [eventPlace]="'Farm Alpha - House A - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Complete'"
                    [assignedTo]="'Mohammed'"
                    [lastDate]="'2024-06-20'"
                ></app-disinfection-current-schedule-tile>
                <app-disinfection-current-schedule-tile
                    [eventName]="'Waterline Disinfection (Every 3 Days)'"
                    [eventPlace]="'Farm Alpha - House A - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Overdue'"
                    [assignedTo]="'Mohammed'"
                    [lastDate]="'2024-06-20'"
                ></app-disinfection-current-schedule-tile>
            </div>
        </div>

        <!-- History Tab -->
        <div *ngIf="isActiveTab('history')" class="tab-pane">
            <div class="insights-parent">
                <app-history-tile
                    [eventName]="'Amoxicillin (Antibiotic)'"
                    [eventPlace]="'Farm Alpha - House B - Partition 1'"
                    [actionDate]="'2024-06-27'"
                    [feedback]="
                        '500ml - Waterline - Applied during morning feed'
                    "
                    [eventStatus]="'Completed'"
                    [assignedTo]="'James Thomas'"
                ></app-history-tile>
            </div>
        </div>

        <!-- Inventory Tab -->
        <div *ngIf="isActiveTab('inventory')" class="tab-pane">
            <div class="inventory-parent">
                <app-inventory-tile
                    [itemName]="'QuaternaryAmmonium'"
                    [stock]="'45L'"
                    [expirationDate]="'Dec 2025'"
                    [stockStatus]="'Good'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'Hydrogen Peroxide'"
                    [stock]="'12L'"
                    [expirationDate]="'Oct 2025'"
                    [stockStatus]="'low'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'ChlorineDioxide'"
                    [stock]="'3L'"
                    [expirationDate]="'Aug 2026'"
                    [stockStatus]="'Critical'"
                >
                </app-inventory-tile>
            </div>
        </div>

        <!-- AI Insights Tab -->
        <div *ngIf="isActiveTab('ai-insights')" class="tab-pane">
            <div class="insights-parent">
                <app-ai-insight-tile
                    [insightTitle]="'Recommendation'"
                    [insightInfo]="
                        'Add fogging between Day 5-7 based on Cycle A15 results showing 12% lower respiratory stress.'
                    "
                >
                </app-ai-insight-tile>

                <app-ai-insight-tile
                    [insightTitle]="'Pattern Detected'"
                    [insightInfo]="
                        'Cycles with consistent daily fogging show 18% better hygiene scores and reduced mortality.'
                    "
                >
                </app-ai-insight-tile>

                <app-ai-insight-tile
                    [insightTitle]="'Success Metrics'"
                    [insightInfo]="
                        'Cycle B12 medication schedule led to 2.3% lower mortality compared to previous cycles.'
                    "
                >
                </app-ai-insight-tile>

                <app-ai-insight-tile
                    [insightTitle]="'Risk Warning'"
                    [insightInfo]="
                        'Disinfection missed 2x this week in House B, NH3 levels elevated by 15%.'
                    "
                >
                </app-ai-insight-tile>
            </div>
        </div>

        <!-- Timeline Tab -->
        <div *ngIf="isActiveTab('timeline')" class="tab-pane">
            <div class="insights-parent">
                <app-timeline-tile
                    [eventName]="'Fogging Completed'"
                    [applyMethod]="'Hydrogen peroxide treatment'"
                    [assignedTo]="'James Thomas'"
                    [dayNumber]="17"
                ></app-timeline-tile>
                <app-timeline-tile
                    [eventName]="'Waterline Cleaning'"
                    [applyMethod]="'Chlorine dioxide treatment'"
                    [assignedTo]="'Mohammed'"
                    [dayNumber]="15"
                ></app-timeline-tile>
            </div>
        </div>
    </div>
</div>
